<template>
  <div class="d-book-gallery">
    <DuiGallery
      class="background-grey"
      :images="vm.bookImages"
    />
  </div>
</template>

<script>
import Vue from 'vue';

import { getErrorMessage } from '@d-shared/utils/errors';

export default {
  data: () => ({
    vm: {
      bookImages: [],
    },
  }),
  mounted() {
    this.loadBookGalleryInfo();
  },
  methods: {
    loadBookGalleryInfo() {
      const bookGalleryInfoEl = document.getElementById('book-gallery-info');
      if (!bookGalleryInfoEl) {
        Vue.duiNotificationManager.error(getErrorMessage(null));
        return;
      }

      try {
        const galleryInfo = JSON.parse(bookGalleryInfoEl.dataset.gallery);
        bookGalleryInfoEl.remove();
        this.setGalleryImages(galleryInfo.illustration_attachments);
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }
    },
    setGalleryImages(illustrationAttachments) {
      this.$set(this.vm, 'bookImages', illustrationAttachments.map(ia => ia.attachment.large.url));
    },
  },
};
</script>
